export class TagsDonneesManquantes {
  public static FEL_CONTRIB = 'FEL-CONTRIB';
  public static FEL_GEST = 'FEL-GEST';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/constants/TagsDonneesManquantes.ts